import { settingsGosplanParams } from '../libs/formats/gosplanParams';
import { gosplan } from '@/restore/reports/gosplan';
import { formatDateParams, formattedDate } from '../libs/time';

/*
    Модель для Гос.План фильтра.
*/

export const gosplanFilterReportModel = {
    name: 'gosplanFilterReport',
    state: {},
    reducers: {},
    effects: () => ({
        getFilterParams(reportTypePath) {
            const filterParams = gosplan.getGosplanParams();
            const { intervalId, period, date, ...otherParams } = filterParams;

            const pathWithSuffix = addSuffix(reportTypePath, intervalId);

            const result = {
                reportType: pathWithSuffix,
            };

            const dateParams = formatDateParams(period, formattedDate(date));
            const commonParams = settingsGosplanParams(otherParams);

            Object.assign(result, dateParams, commonParams);

            return result;
        },
    }),
};

/*
    Добавляет к пути суффикс _intervalId к общему пути для отчета
*/
function addSuffix(path, intervalId) {
    return `${path}_${intervalId}`;
}
